module.exports = "data:image/svg+xml,module.exports = __webpack_public_path__ + 'fonts/jdf-inline-logoece35a236ea5d245d6a7e0733005655a.svg';"